import { useUserQuery } from '../gen/user'
import { CurrencyCode } from '@repo/graphql-types'
import type { Currency } from '@repo/graphql-types'
import { useCookies } from 'react-cookie'
import { CURRENCY_COOKIE_NAME } from 'constants/cookies'

const currencyData: Currency[] = [
  {
    code: CurrencyCode.Usd,
    symbol: '$',
  },
  {
    code: CurrencyCode.Eur,
    symbol: '€',
  },
  {
    code: CurrencyCode.Gbp,
    symbol: '£',
  },
]

function currencyCodeToCurrency(value?: string) {
  return (
    currencyData.find(currency => currency.code === value?.toLowerCase()) ?? {
      code: CurrencyCode.Usd,
      symbol: '$',
    }
  )
}

export function useCurrentCurrency() {
  const [currencyCookie] = useCookies([CURRENCY_COOKIE_NAME])
  const currency: string | undefined = currencyCookie.currency
  // eslint-disable-next-line cf-web/codegen-query-patterns
  const response = useUserQuery(undefined, {
    select: data => data?.me?.user?.currency.code || data?.me?.currency?.code || CurrencyCode.Usd,
    enabled: !currency,
  })

  return currencyCodeToCurrency(currency || response.data)
}
